import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  Consumable,
  CreateConsumableRequest,
  ListConsumablesQuery,
  UpdateConsumableRequest,
} from './Consumables.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/consumables`;

export async function listConsumables(
  params?: ListConsumablesQuery,
): Promise<PageResult<Consumable>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Consumable>;
}

export async function getConsumable(id: number): Promise<Consumable> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Consumable;
}

export async function createConsumable(
  obj: CreateConsumableRequest,
): Promise<Consumable> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Consumable;
}

export async function updateConsumable(
  obj: UpdateConsumableRequest,
): Promise<Consumable> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Consumable;
}

export async function deleteConsumable(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function consumableActivateOrInactivate(consumableId: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${consumableId}/activate`,
    {},
    null,
  )) as unknown;

  return result;
}
